import React from 'react';
import _ from 'lodash';
import notify from 'rawr/notify';
import promise from 'rawr/utils/promise';
import Logger from 'rawr/utils/Logger';

/*
Whenever the component mounts/updates, the params function will be called with
the current props and state. It should return a value containing any data
required by the promise function to create a promise for the data. If no params
function is included, it will default to returning the entire props object.

If the params are deeply equal between changes, the promise will not be refreshed.

An optional refresh function will be passed the previous and new params values,
and can return true if the data should be refreshed.

React.createClass({
	mixins: [AsyncData2],
	data: {
		foo: {
			params: p => ({foo: p.foo}),
			refresh: (n, o) => n !== o,  // optional, defaults to _.isEqual
			promise: p => api(`/api/${p.foo}`),
		}
	}
});
*/

export default {
	getInitialState() {
		return {};
	},
	_update(newProps, oldProps, newState, oldState, keys) {
		const pending = {};

		_.forEach(this.data, ({
			params=p => p,
			refresh=(n, o) => !_.isEqual(n, o),
			promise,
		}, key) => {
			// If any keys have been specified (currently only used by the `refreshData`
			// method), only process those item.
			if (!keys || keys.length === 0 || keys.includes(key)) {

				const newParams = params(newProps, newState);
				const initialRun = _.isNull(oldProps) || _.isNull(oldState);

				if (initialRun || refresh(newParams, params(oldProps, oldState))) {
					pending[`${key}Loading`] = Promise.resolve(promise(newParams))
						.then(data => {
							const loading = this.state[`${key}Loading`];
							if (loading === pending[`${key}Loading`]) {
								this.setState({
									[key]: data,
									[`${key}Loading`]: false,
									[`${key}Error`]: false
								});
							} else {
								if (console) console.info(`Pending request for ${key} superseded.`);
							}
						})
						.catch(reason => {
							if (console) console.error(reason);
							notify.error(reason);
							Logger.captureException(reason);
							this.setState({
								[`${key}Loading`]: false,
								[`${key}Error`]: reason,
							});
							throw reason;
						});
				}
			}
		});
		if (!_.isEmpty(pending)) {
			this.setState(pending);
		}
		return promise.props(pending);
	},
	componentWillMount() {
		this._update(this.props, null, this.state, null);
	},
	componentWillReceiveProps(nextProps) {
		this._update(nextProps, this.props, this.state, this.state);
	},
	componentWillUpdate(nextProps, nextState) {
		if (nextState !== this.state) {
			this._update(nextProps, this.props, nextState, this.state);
		}
	},
	refreshData(...keys) {
		return this._update(this.props, null, this.state, null, keys);
	}
};



/** WEBPACK FOOTER **
 ** core/client/rawr/mixins/AsyncData2.jsx
 **/